import type { ApiClient } from "@/lib/api";

export type ValidateCustomVerifierRequest = {
  user_id: string;
  verifier_url: string;
};

export type ValidateCustomVerifierResponse = {
  flow_id: string;
  next_uri: string;
};

export const testCustomVerifier = async (options: {
  client: ApiClient;
  payload: ValidateCustomVerifierRequest;
}): Promise<ValidateCustomVerifierResponse> => {
  const { client, payload } = options;
  const { data } = await client.post<ValidateCustomVerifierResponse>(
    "/auth/validate_custom_verifier",
    payload
  );

  return data;
};
